// Template257: Bélgica - Día 5 Brujas y Bruselas (Page15.jsx)
// Hero dia5 + título Brujas y Bruselas + sticker, intro, caja Brujas, Atomium, tip Parque + sticker, Barrio Europeo, Mini-Europe.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template257 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const cajaBrujas = page?.texts?.[2]?.content;
	const atomiumTitle = page?.texts?.[3]?.content;
	const atomiumBody = page?.texts?.[4]?.content;
	const tipParque = page?.texts?.[5]?.content;
	const barrioTitle = page?.texts?.[6]?.content;
	const barrioBody = page?.texts?.[7]?.content;
	const miniTitle = page?.texts?.[8]?.content;
	const miniBody = page?.texts?.[9]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2");
	const stickerEuropa = getImageSrc("img2-sticker") || getImageSrc("img3");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				<Box
					component="h1"
					sx={{
						fontSize: isSmallScreen ? 28 : 32,
						textAlign: "center",
						position: "absolute",
						bottom: 0,
						margin: "10px",
						left: 20,
						color: "#fff",
						textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						fontWeight: 700,
					}}
				>
					Brujas y Bruselas
				</Box>
				{portadaSticker && (
					<Box
						component="img"
						src={portadaSticker}
						alt=""
						sx={{ width: 100, position: "absolute", bottom: 60, left: 20 }}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box
						component="p"
						sx={{ fontSize: 13, color: "#333", margin: 0, padding: 0 }}
					>
						{intro}
					</Box>
				)}

				{cajaBrujas && (
					<Box
						data-block-id="text-2"
						sx={{
							backgroundColor: "#fef9e6",
							border: "2px solid #D4A017",
							borderRadius: "12px",
							padding: "14px 16px",
							marginTop: "10px",
						}}
					>
						<Box component="p" sx={estiloP}>
							{cajaBrujas}
						</Box>
					</Box>
				)}

				<Box
					data-block-id="text-3"
					sx={{
						position: "relative",
						display: "flex",
						flexDirection: "column",
						gap: 2,
						marginTop: "16px",
					}}
				>
					{/* Atomium */}
					{(atomiumTitle || atomiumBody) && (
						<Box data-block-id="text-4" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[0] && (
								<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[0].icono}
										texto={sabiasQue[0].texto}
									/>
								</Box>
							)}
							{sabiasQue[1] && (
								<Box sx={{ position: "absolute", top: -10, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[1].icono}
										texto={sabiasQue[1].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%" }}>
								{atomiumTitle && (
									<Box component="h3" sx={estiloH3}>
										{atomiumTitle}
									</Box>
								)}
								{atomiumBody && (
									<Box component="p" sx={estiloP}>
										{atomiumBody}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{tipParque && (
						<Box
							sx={{
								position: "absolute",
								bottom: 80,
								right: 50,
								backgroundColor: "#fff8db",
								border: "2px solid #D4A017",
								borderRadius: "16px 16px 0px 16px",
								padding: "10px 12px",
								fontSize: "11px",
								color: "#444",
								boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
								maxWidth: 250,
								zIndex: 3,
							}}
							dangerouslySetInnerHTML={{ __html: tipParque }}
						/>
					)}
					{stickerEuropa && (
						<Box
							component="img"
							src={stickerEuropa}
							alt=""
							sx={{
								width: 100,
								position: "absolute",
								bottom: 50,
								right: -20,
								zIndex: 2,
							}}
						/>
					)}

					{/* Barrio Europeo */}
					{(barrioTitle || barrioBody) && (
						<Box data-block-id="text-5" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img2 && (
								<Box
									component="img"
									src={img2}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[2] && (
								<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[2].icono}
										texto={sabiasQue[2].texto}
									/>
								</Box>
							)}
							{sabiasQue[3] && (
								<Box sx={{ position: "absolute", top: -10, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[3].icono}
										texto={sabiasQue[3].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%" }}>
								{barrioTitle && (
									<Box component="h3" sx={estiloH3}>
										{barrioTitle}
									</Box>
								)}
								{barrioBody && (
									<Box component="p" sx={estiloP}>
										{barrioBody}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Mini-Europe */}
					{(miniTitle || miniBody) && (
						<Box
							data-block-id="text-6"
							sx={{
								width: "100%",
								position: "relative",
								marginTop: isSmallScreen ? "40px" : 0,
							}}
						>
							{sabiasQue[4] && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? -20 : -10,
										right: "45%",
									}}
								>
									<SabiasQue
										icono={sabiasQue[4].icono}
										texto={sabiasQue[4].texto}
									/>
								</Box>
							)}
							<Box
								sx={{
									padding: "12px",
									backgroundColor: "#f9ebc8",
									borderRadius: "12px",
									fontSize: 13,
									color: "#000",
								}}
							>
								{miniTitle && (
									<Box component="h3" sx={estiloH3}>
										{miniTitle}
									</Box>
								)}
								{miniBody && (
									<Box component="span" sx={estiloP}>
										{miniBody}
									</Box>
								)}
							</Box>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template257.thumbnail = "/images/template-1.png";
export default Template257;
